<template>
  <div
    class="policy"
    :class="{
      'after-bottom-divider': !(lastChild || (hasTable && !refundPolicy.tips)),
    }"
  >
    <div class="policy-title" v-if="scene === 'TAG'"><img :src="icon" class="policy-icon" />{{ refundPolicy.title }}</div>
    <div>
      <div class="policy-content" :style="!hasTable && refundPolicy.tips && refundPolicy.content ? 'margin-bottom:0;' : ''" v-if="refundPolicy.content">{{ refundPolicy.content }}</div>
      <template v-if="refundPolicy.refundRuleList && refundPolicy.refundRuleList.length">
        <div class="policy-tab-container">
          <div class="event-options" ref="scroll-container">
            <div
              v-for="(item, index) in refundPolicy.refundRuleList"
              :key="item.name || index"
              :class="['event-options-item', targetPolicy.name === item.name ? 'event-options-item-active' : '']"
              @click="selectEvent(item, index)"
              :ref="`event-option-${index}`"
              role="button"
              tabindex="0"
            >
              {{ item.name }}
            </div>
          </div>
          <refund-policy-table :policy-obj="targetPolicy" type="REFUND" />
        </div>
        <!-- <refund-policy-table :policy-obj="item" v-for="item in refundPolicy.refundRuleList" :type="refundPolicy.type" :key="item.id"/> -->
      </template>
      <template v-if="refundPolicy.noTicketCompensateStandardVOList && refundPolicy.noTicketCompensateStandardVOList.length">
        <refund-policy-table :policy-array="refundPolicy.noTicketCompensateStandardVOList" :type="refundPolicy.type" />
      </template>
      <div class="policy-tips" :style="!hasTable && refundPolicy.tips && refundPolicy.content ? 'margin-top:0;' : ''">{{ refundPolicy.tips }}</div>
    </div>
  </div>
</template>
<script>
import RefundPolicyTable from "components/RefundPolicyTable";
const iconYes = "https://static.piaoniu.com/img/policy-icon2.png";
const iconNo = "https://static.piaoniu.com/img/policy-icon.png";
export default {
  name: "RefundPolicy",
  components: {
    RefundPolicyTable,
  },
  props: {
    refundPolicy: {
      type: Object,
      default: () => {},
      required: true,
    },
    scene: {
      type: String,
    },
    lastChild: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      targetPolicy: {},
    };
  },
  mounted() {
    this.targetPolicy = (this.refundPolicy.refundRuleList && this.refundPolicy.refundRuleList[0]) || {};
  },
  methods: {
    selectEvent(item, index) {
      this.targetPolicy = item;
      this.scroll(index);
    },
    scroll(index) {
      this.$nextTick(() => {
        const activeOptionComp = this.$refs[`event-option-${index}`];
        const element = activeOptionComp && activeOptionComp[0];
        const container = this.$refs["scroll-container"];

        if (element && container) {
          const targetScrollLeft = element.offsetLeft;
          // 将平滑滚动时间延长至300ms以获得视觉上的连贯与丝滑
          this.smoothScrollTo(container, targetScrollLeft, 300);
        }
      });
    },
    smoothScrollTo(container, target, duration) {
      // 1. 优先使用原生平滑滚动方案（性能最佳、极其丝滑）
      if (typeof container.scrollTo === "function" && "behavior" in document.documentElement.style) {
        container.scrollTo({
          left: target,
          behavior: "smooth",
        });
        return;
      }

      // 2. 降级过渡动画方案
      const start = container.scrollLeft;
      const change = target - start;
      if (change === 0) return;

      const startTime = performance.now();
      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        let progress = elapsed / duration;
        if (progress > 1) progress = 1;

        // 使用 easeOutQuart 特效：启动迅捷，逐渐无比轻缓地停下
        const ease = 1 - Math.pow(1 - progress, 4);
        container.scrollLeft = start + change * ease;

        if (progress < 1) {
          window.requestAnimationFrame(animateScroll);
        }
      };

      window.requestAnimationFrame(animateScroll);
    },
  },
  computed: {
    icon() {
      return this.refundPolicy.title === "预售" || this.refundPolicy.title === "不支持退" ? iconNo : iconYes;
    },
    hasTable() {
      return (
        (this.refundPolicy.refundRuleList && this.refundPolicy.refundRuleList.length) ||
        (this.refundPolicy.noTicketCompensateStandardVOList && this.refundPolicy.noTicketCompensateStandardVOList.length)
      );
    },
  },
};
</script>
<style lang="less" scoped>
.policy {
  background-color: #ffffff;
  position: relative;
  box-sizing: border-box;
}
.after-bottom-divider {
  &::after {
    content: "";
    display: block;
    margin-bottom: 12px;
    width: 100%;
    height: 1px;
    // background-color: red;
    background-color: #f5f5f5;
  }
}
.policy-icon {
  margin-right: 2px;
  width: 18px;
  height: 18px;
}
.policy-title {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #262626;
}
.policy-tips,
.policy-content {
  margin: 6px 0 12px;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #666666;
  white-space: pre-wrap;
}
.policy-tab-container {
  .event-options {
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    width: 100%;
    padding-bottom: 6.5px;
    position: relative;
    //隐藏滚动条
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }

    // .event-options-item {
    //   padding: 10px;
    //   background: #f5f5f5;
    //   color: #262626;
    //   border-radius: 8px;
    //   margin-right: 8px;
    //   font-family: PingFang SC;
    //   font-weight: 500;
    //   font-size: 11px;
    //   line-height: 16px;
    //   white-space: nowrap;
    //   box-sizing: border-box;
    //   text-size-adjust: none;
    //   min-width: fit-content;
    //   overflow: hidden;

    //   &-active {
    //     // https://static.piaoniu.com/img/border-active.png

    //     padding: 10px 10px 13px;
    //     border-image-width: 8px;
    //     border-image-slice: 24;
    //     border-image-source: url("https://static.piaoniu.com/img/border-active.png");
    //     border-image-repeat: stretch;
    //     background: linear-gradient(180deg, #fef2f5 79%, #fff 81%);
    //   }
    // }
    // .event-options-outer-item {
    //   padding: 1px 0px 6px;
    //   color: #262626;
    //   margin-right: 8px;
    //   white-space: nowrap;
    //   box-sizing: border-box;
    //   text-size-adjust: none;
    //   min-width: fit-content;
    //   overflow: hidden;
    //   &-active {
    //     color: #262626;
    //     font-size: 11px;
    //     box-sizing: border-box;
    //     background-image: url("https://static.piaoniu.com/img/border-active.png");
    //     background-size: 100%;
    //     background-repeat: no-repeat;
    //     background-position: center;
    //   }
    //   .event-options-inner-item {
    //     padding: 10px;
    //     background-color: #f5f5f5;
    //     border-radius: 8px;
    //     &-active {
    //       color: #262626;
    //       font-family: PingFang SC;
    //       font-weight: 500;
    //       font-size: 11px;
    //       line-height: 16px;
    //       box-sizing: border-box;
    //       background-color: #fef2f5;
    //     }
    //   }
    // }
    .event-options-item {
      padding: 10px;
      background: #f5f5f5;
      color: #262626;
      border-radius: 8px;
      margin-right: 8px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 11px;
      line-height: 16px;
      white-space: nowrap;
      box-sizing: border-box;
      text-size-adjust: none;
      min-width: fit-content;

      /* Webview 点击与交互兼容性增强 */
      cursor: pointer;
      user-select: none;
      -webkit-user-select: none;
      -webkit-tap-highlight-color: transparent;
      touch-action: pan-x; /* 防止横向滑动误触 */
      &-active {
        background: #fef2f5;
        position: relative;
        z-index: 1;
        border: 1px solid #ff2261;
        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 1px;
          left: 50%;
          width: 22px;
          height: 7px;
          transform: translate(-50%, 100%);
          background: url("https://static.piaoniu.com/event-active-icon.png");
          background-size: 100% 7px;
          background-repeat: no-repeat;
          background-position: center -1px;
          z-index: 50;
          border-top: 1px solid #fef2f5;
        }
        // https://static.piaoniu.com/img/border-active.png

        // padding: 10px 10px 13px;
        // border-image-width: 8px;
        // border-image-slice: 24;
        // border-image-source: url("https://static.piaoniu.com/img/border-active.png");
        // border-image-repeat: stretch;
        // background: linear-gradient(180deg, #fef2f5 79%, #fff 81%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// RefundPolicy.vue?13e00086